import React from "react";
import { string } from "prop-types";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import Markdown from "react-markdown";

import OutboundLink from "./OutboundLink";

const DefinitionList = ({ term, definition }) => (
  <dl key={term}>
    <dt>{term}</dt>
    <Markdown
      skipHtml={true}
      components={{
        p: "dd",
        a: OutboundLink,
      }}
    >
      {definition}
    </Markdown>
  </dl>
);

DefinitionList.propTypes = {
  term: string.isRequired,
  definition: string.isRequired,
};

const GlossaryContent = React.memo(function GlossaryContent({ i18nKey }) {
  const { t } = useTranslation();
  const terms = t(i18nKey);
  return (
    <Box
      component="dl"
      sx={{
        "& dl": {
          marginTop: "8px",
          "& dt": {
            margin: 0,
            fontWeight: "bold",
          },
          "& dd": {
            marginTop: "4px",
          },
        },
      }}
    >
      {terms.map(DefinitionList)}
    </Box>
  );
});

GlossaryContent.propTypes = {
  i18nKey: string.isRequired,
};

export default GlossaryContent;
